import { type ForwardedRef, forwardRef, type HTMLProps, memo, type ReactNode } from 'react';

import { AudioPlayer } from '../../../audio-player/AudioPlayer';

export type AudioProps = Omit<HTMLProps<HTMLElement>, 'ref'> & {
  href: string;
  caption?: ReactNode;
};

export const AudioBase = forwardRef(
  ({ href, caption = null, ...props }: AudioProps, ref: ForwardedRef<HTMLElement>) => (
    <figure {...props} ref={ref}>
      <AudioPlayer src={href} />

      {!!caption && <figcaption>{caption}</figcaption>}
    </figure>
  ),
);

AudioBase.displayName = 'Audio';

export const Audio = memo(AudioBase);
